import React from "react";
import { Divider, Row } from "antd";
import { ISectionProps, ISectionTitleProps } from "./interface";
import ZTypography from "@atoms/ZTypography";
import ZIcon from "@atoms/ZIcon";
import { ZTooltip } from "../../atoms";
import { EIcons } from "../../atoms/ZIcon/interface";

const { ZSectionHeading, ZSectionSubheading } = ZTypography;

export const ZSectionTitle: React.FC<ISectionTitleProps> = React.memo(props => (
	<Row>
		{(props.icon || props.iconPlaceholder) && (
			<ZIcon
				name={props.icon}
				isTwoToneIcon={props.isTwoToneIcon || false}
				className={`ml-0 mr-2 ${
					props.iconPlaceholder ? "invisible" : ""
				}`}
			/>
		)}
		<div>
			<div className="flex items-center">
				{props.heading && (
					<ZSectionHeading
						className={
							props.icon || props.shouldHideSectionPadding
								? ""
								: "pb-1"
						}
					>
						{props.heading}
					</ZSectionHeading>
				)}
				{props.extra && props.extra}
			</div>
			{props.subHeading && (
				<ZSectionSubheading
					colorVariant={8}
					level={1}
					className="block mt-1"
				>
					{props.subHeading}
					{props.showSubheadingTooltip && (
						<ZTooltip
							placement="top"
							title="Default style will be applicable to all new Zomentum documents. Your existing templates will not be updated."
						>
							<ZIcon
								name={EIcons.INFOCIRCLE}
								size="sm"
								className="ml-1"
								colorVariant={7}
							/>
						</ZTooltip>
					)}
				</ZSectionSubheading>
			)}
		</div>
	</Row>
));

const ZSection: React.FC<ISectionProps> = React.memo(
	({
		className = "",
		children,
		leftPaddingForChildren = "pl-10",
		shouldApplyLeftPaddingForChildren = true,
		bottomBorder = true,
		last = true,
		first = true,
		...rest
	}) => {
		return (
			<div className={className}>
				<ZSectionTitle {...rest} />
				{first && <div className="pb-md" />}
				<div
					className={
						shouldApplyLeftPaddingForChildren
							? leftPaddingForChildren
							: ""
					}
				>
					{children}
				</div>
				{bottomBorder && <Divider className="mt-4"></Divider>}
				{last && <div className="pb-md"></div>}
			</div>
		);
	}
);

export default ZSection;
